import { configureStore, Middleware } from '@reduxjs/toolkit';
import rootReducer from './reducers/rootReducer';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './saga/rootSaga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { storage_key } from './constants';

const config = {
  key: storage_key,
  storage: storage,
  whitelist: [
    'getTherapistProfileReducer',
    'getFacilityDropDownReducer',
    'storeFacilityUuidReducer',
    'updateFacilityDropDownReducer',
    'getPatientIdReducer',
    'switchDisciplineReducer',
    'checkoutReducer',
    'getSignatureAccessReducer',
    'storeSubdomainReduxReducer',
    'thePayComeDetailsReducer',
    'getMdsFormIdReducer',
    'checkInReducer',
    'getAllFilteredTherapistsReducer',
    'dashboardCreateEditDocumentDataReducer',
    'eocCreateDocumentDataReducer',
    'eocEditDocumentDataReducer',
    'checkIsReformReducer',
  ],
};

const sagaMiddleware = createSagaMiddleware();

const middleware: Middleware[] = [sagaMiddleware];

const reducers = persistReducer(config, rootReducer);

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(middleware),
});

export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export const reduxStore = store;
